var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 144,
    viewBox: "0 0 203 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.692 123.068C131.745 122.991 134.181 120.493 134.181 117.439V24.1889C134.181 20.7708 131.41 17.9999 127.992 17.9999H58.9071C54.54 17.9999 50.9998 21.5401 50.9998 25.9072V104.396C50.9998 115.703 60.3168 124.789 71.6204 124.504L128.692 123.068Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6204 124.504L71.5495 121.69L71.6204 124.504ZM128.692 123.068L128.763 125.882L128.692 123.068ZM131.366 117.439V24.1889H136.996V117.439H131.366ZM127.992 20.8151H58.9071V15.1847H127.992V20.8151ZM53.815 25.9072V104.396H48.1846V25.9072H53.815ZM71.5495 121.69L128.621 120.253L128.763 125.882L71.6912 127.319L71.5495 121.69ZM53.815 104.396C53.815 114.121 61.828 121.935 71.5495 121.69L71.6912 127.319C58.8057 127.643 48.1846 117.286 48.1846 104.396H53.815ZM58.9071 20.8151C56.0948 20.8151 53.815 23.0949 53.815 25.9072H48.1846C48.1846 19.9853 52.9852 15.1847 58.9071 15.1847V20.8151ZM131.366 24.1889C131.366 22.3256 129.855 20.8151 127.992 20.8151V15.1847C132.964 15.1847 136.996 19.216 136.996 24.1889H131.366ZM136.996 117.439C136.996 122.021 133.343 125.767 128.763 125.882L128.621 120.253C130.148 120.215 131.366 118.966 131.366 117.439H136.996Z",
    fill: "#00ABC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.175 125.035C152.757 120.495 154.504 101.984 144.718 94.2647H66.7797C74.942 98.8406 80.5416 120.844 66.7797 125.035H140.175Z",
    fill: "white",
    stroke: "#00ABC5",
    strokeWidth: 3.75354,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.377 83.7466C119.377 81.568 117.611 79.8018 115.432 79.8018H70.6551C68.4765 79.8018 66.7103 81.568 66.7103 83.7466C66.7103 85.9253 68.4765 87.6914 70.6551 87.6914H115.432C117.611 87.6914 119.377 85.9253 119.377 83.7466Z",
    fill: "#00ABC5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.377 60.0767C119.377 57.8981 117.611 56.1319 115.432 56.1319H70.6551C68.4765 56.1319 66.7103 57.8981 66.7103 60.0767C66.7103 62.2553 68.4765 64.0215 70.6551 64.0215H115.432C117.611 64.0215 119.377 62.2553 119.377 60.0767Z",
    fill: "#00ABC5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.446 36.4087C119.446 34.2301 117.68 32.4639 115.502 32.4639H70.7245C68.5458 32.4639 66.7797 34.2301 66.7797 36.4087C66.7797 38.5874 68.5458 40.3535 70.7245 40.3535H115.502C117.68 40.3535 119.446 38.5874 119.446 36.4087Z",
    fill: "#00ABC5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvHover);
export default __webpack_public_path__ + "static/media/cvHover.ddc699345026d8bc53adb30939e0cf9d.svg";
export { ForwardRef as ReactComponent };